module.exports = __webpack_public_path__ + "static/media/FedDev.fa22b02b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/logos/FedDev.png
// module id = 928
// module chunks = 0